// import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from 'app/store';

export const selectCaseShares = (state:RootState) => state[Reducers.CaseShares].caseShares;
export const selectLoading = (state:RootState) => state[Reducers.CaseShares].loading;
